export enum Modes {
    EVERY = "EVERY",
    LATEST = "LATEST"
}
